export default __webpack_public_path__ + "8a7c165e8ddb5a35d3e43164cf03fd8c.png";